import { Flex, Image, Text } from '@chakra-ui/react';
import { Color } from 'presentation/theme/colorScheme';
import { FC } from 'react';

export interface ContextMenuItemData {
  icon: string;
  text: string;
  textColor?: string;
  onClick: () => void;
}

const ContextMenuItem: FC<ContextMenuItemData> = ({
  icon,
  text,
  textColor = '#000',
  onClick,
}) => {
  return (
    <Flex
      alignItems="center"
      py="10px"
      px="12px"
      onClick={onClick}
      cursor="pointer"
      bgColor="#fff"
      _hover={{
        bgColor: Color.Shade200,
      }}
    >
      <Image src={icon} mr="10px" w="20px" h="20px" />
      <Text color={textColor} fontSize="14px">
        {text}
      </Text>
    </Flex>
  );
};

export default ContextMenuItem;
